/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { LoadingSection } from '@coursera/cds-core';

import PDFJSRenderer from 'bundles/ent-website/components/PDFJSRenderer';
import PDFObjectRenderer from 'bundles/ent-website/components/PDFObjectRenderer';
import isPDFSupported from 'bundles/ent-website/utils/isPDFSupported';
import EnterpriseWebsiteExperiments from 'bundles/epic/clients/EnterpriseWebsite';

type Props = {
  url: string;
};

function PdfViewer({ url }: Props) {
  const [isNativePDFSupported, setIsNativePDFSupported] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    setIsNativePDFSupported(isPDFSupported());
  }, []);

  if (isNativePDFSupported === undefined) {
    return <LoadingSection />;
  }

  return isNativePDFSupported && EnterpriseWebsiteExperiments?.get('isPDFObjectEnabled') ? (
    <PDFObjectRenderer url={url} />
  ) : (
    <PDFJSRenderer url={url} />
  );
}

export default PdfViewer;
